<template>
  <div class="header">
    <div class="header-content container">
      <div class="header-text split">
        <h1 v-html="content.title"></h1>
        <p v-html="content.subTitle"></p>
        <Button v-if="!smallerScreen" :link="content.button.url">{{
          content.button.text
        }}</Button>
      </div>
      <div class="header-image split">
        <video autoplay loop muted playsinline :src="content.image" />
      </div>
      <Button
        class="secondary-button"
        v-if="smallerScreen"
        :link="content.button.url"
        >{{ content.button.text }}</Button
      >
    </div>
    <!-- <div class="header-subcontent container">
      <p class="special-offer">
        To learn more about securing your Eyejack Edu student licenses please
        send an enquiry to info+edu@eyejackapp.com.
      </p>
      <div class="special-offer-burst">
        <p>Special Offer</p>
        <p style="font-weight: bold;">USD $29.95*</p>
        <p>(per annual student licence)</p>
      </div>
    </div> -->
  </div>
    <!-- <div class="header-subcontent container">
      <div class="special-offer-burst">
        <p>Special Offer</p>
        <p style="font-weight: bold;">USD $29.95*</p>
        <p>(per annual student licence)</p>
      </div>
      <p class="special-offer">
        To learn more about securing your EyeJack Edu student licenses please
        send an enquiry to <a href="mailto:info+edu@eyejackapp.com" target="_blank" style="text-decoration: underline; text-decoration-thickness: 0em;">info+edu@eyejackapp.com</a>.
      </p>
    </div> -->
</template>

<script>
import Button from "./Button.vue";
import { ref, onMounted, onUnmounted } from "vue";
export default {
  name: "Header",
  components: {
    Button,
  },
  props: ["content"],
  setup(props) {
    console.log(props.buttonLink);
    // const mobileView = inject("mobileView");
    const smallerScreen = ref(0);

    const handleView = () => {
      smallerScreen.value = window.innerWidth < 768;
    };

    handleView();
    onMounted(() => window.addEventListener("resize", handleView));
    onUnmounted(() => window.removeEventListener("resize", handleView));
    return {
      smallerScreen,
    };
  },
};
</script>

<style lang="scss">
@import "../styles/styles.scss";
.secondary-button {
  margin-bottom: 10em !important;
}
.header {
  background: #fbfbfb;
  min-height: calc(100vh - 80px);
  max-height: 100%;
  display: flex;

  .header-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 0.58em;
    width: 100%;
    margin: auto;
    padding-top: 2em;
    padding-bottom: 0;

    .header-text {
      padding-right: 0;
    }
    h1 {
      line-height: 40px;
      padding: 0.5em 0;
    }
    p {
      line-height: 30px;
      padding: 0.5em 0;
    }
    .header-image {
      margin: 2em auto;
      max-width: 800px;
      padding: 0em 4em;
      video {
        width: 100%;
        height: auto;
      }
    }
  }
  flex-direction: column;
}


@include media(">phone-md") {
  .header {
    .header-content {
      font-size: 1em;
      h1 {
        line-height: 60.94px;
      }
      p {
        line-height: 40px;
      }
    }
  }
  .header-subcontent {

  }
}
@include media(">=tablet") {
  .header {
    .container {
      padding-right: 0;
      // margin-right: 0;
    }
    .header-content, .header-subcontent {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .header-text {
        // padding-right: 1em;
        flex-basis: 48%;
      }
      .header-image {
        margin: 0;
        padding: 0.5em 0;
        flex-basis: 60%;

      }
    }
  }
}
@include media(">=desktop") {
  // .header {
  //   .header-content {
  //     h1 {
  //       width: 80%;
  //     }
  //     p {
  //       width: 87%;
  //     }
  //   }
  // }
}
</style>